import React, { useEffect, useState } from "react";
import EmptyState from "../Global/EmptyState";
import TenantTableSkeleton from "./TenantTableSkeleton";
import TenantTable from "./TenantTable";
import TenantTableHeader from "./TenantTableHeader";
import {
  allTenants,
  setTenants,
  allAssignments,
  setAssignments,
  activeTenantActions,
} from "../../Features/Tenants/tenantSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  getAllTenants,
  getAllAssignments,
  getAllCustomerOverviewSnapshots,
} from "../../Services/CommandCenterService";
import AddTenantModal from "./AddTenantModal";
import { CustomerOverviewSnapshot } from "../../Models/CustomerOverviewSnapshot";

const Tenants: React.FC = () => {
  const [loading, setIsLoading] = useState(true);
  const [overviewByTenantId, setOverviewByTenantId] = useState<
    Record<string, CustomerOverviewSnapshot>
  >({});
  const dispatch = useAppDispatch();
  const tenants = useAppSelector(allTenants);
  const assignments = useAppSelector(allAssignments);
  const actions = useAppSelector(activeTenantActions);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAllTenants();
      dispatch(setTenants(data));
      setIsLoading(false);

      const [assignmentsResult, snapshotsResult] = await Promise.all([
        getAllAssignments(),
        getAllCustomerOverviewSnapshots().catch(
          () => [] as CustomerOverviewSnapshot[]
        ),
      ]);

      const nextOverviewByTenantId = snapshotsResult.reduce(
        (acc, snapshot) => {
          if (snapshot?.azureTenantId) {
            acc[snapshot.azureTenantId] = snapshot;
          }
          return acc;
        },
        {} as Record<string, CustomerOverviewSnapshot>
      );

      dispatch(setAssignments(assignmentsResult));
      setOverviewByTenantId(nextOverviewByTenantId);
    };
    fetchData();
  }, [dispatch]);

  if (loading) {
    return (
      <>
        <TenantTableHeader />
        <TenantTableSkeleton />
      </>
    );
  }

  return (
    <>
      <TenantTableHeader />

      {tenants.length ? (
        <TenantTable
          tenants={tenants}
          assignments={assignments}
          overviewByTenantId={overviewByTenantId}
        />
      ) : (
        <EmptyState
          heading="You haven't added any tenants."
          text="Let's get started"
        >
          <AddTenantModal>Add your first tenant</AddTenantModal>
        </EmptyState>
      )}
    </>
  );
};

export default Tenants;
